"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.useStore = exports.initializeStore = exports.useAppSelector = exports.useAppDispatch = void 0;
const react_1 = require("react");
const toolkit_1 = require("@reduxjs/toolkit");
const react_redux_1 = require("react-redux");
const form_1 = __importDefault(require("./form"));
let store;
// Use throughout your app instead of plain `useDispatch` and `useSelector`
const useAppDispatch = () => (0, react_redux_1.useDispatch)();
exports.useAppDispatch = useAppDispatch;
exports.useAppSelector = react_redux_1.useSelector;
function initStore(preloadedState = {}) {
    return (0, toolkit_1.configureStore)({
        preloadedState,
        reducer: form_1.default,
    });
}
const initializeStore = (preloadedState) => {
    let _store = store !== null && store !== void 0 ? store : initStore(preloadedState);
    // After navigating to a page with an initial Redux state, merge that state
    // with the current state in the store, and create a new store
    if (preloadedState && store) {
        _store = initStore(Object.assign(Object.assign({}, store.getState()), preloadedState));
        // Reset the current store
        // @ts-ignore
        store = undefined;
    }
    // For SSG and SSR always create a new store
    if (typeof window === 'undefined')
        return _store;
    // Create the store once in the client
    if (!store)
        store = _store;
    return _store;
};
exports.initializeStore = initializeStore;
function useStore(initialState) {
    const store = (0, react_1.useMemo)(() => (0, exports.initializeStore)(initialState), [initialState]);
    return store;
}
exports.useStore = useStore;
